export const AgreementType = {
    Producer: 'Producer',
    Organization: 'Organization',
}